import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.less'
})
export class ErrorComponent implements OnInit {
  private currentErrors: any;
  private currentErrorKey?: string;

  @Input()
  set errors(value: any) {
    this.currentErrors = value;
    this.setup();
  }
  @Input() errorMessage: string| undefined;
  @Input() btnCancelText: string| undefined;
  @Input()
  set ErrorKey(value: string | undefined) {
    this.currentErrorKey = value;
    this.setup();
  }

  get ErrorKey(): string | undefined {
    return this.currentErrorKey;
  }

  messages: string[] = [];
  showAlert = false;
  constructor() { }

  ngOnInit(): void {
  }

  private normalizeKey(value: string | undefined | null): string {
    if (!value) {
      return '';
    }

    const lastSegment = value.split('.').pop() || value;
    return lastSegment.trim().toLowerCase();
  }

  private isGlobalKey(value: string | undefined): boolean {
    const normalized = this.normalizeKey(value);
    return !normalized || normalized === 'general' || normalized === 'global' || normalized === 'error';
  }

  private parseErrorItems(errors: any): Array<{ Key?: string; Errors: string[] }> {
    if (!errors) {
      return [];
    }

    if (Array.isArray(errors)) {
      return errors
        .filter((item: any) => !!item)
        .map((item: any) => ({
          Key: item.Key,
          Errors: Array.isArray(item.Errors)
            ? item.Errors.map((msg: any) => String(msg))
            : item.Errors
              ? [String(item.Errors)]
              : []
        }));
    }

    if (errors.errors) {
      return this.parseErrorItems(errors.errors);
    }

    if (typeof errors === 'object') {
      return Object.keys(errors).map((key: string) => {
        const value = errors[key];
        return {
          Key: key,
          Errors: Array.isArray(value) ? value.map((msg: any) => String(msg)) : [String(value)]
        };
      });
    }

    return [{ Errors: [String(errors)] }];
  }

  setup() {
    const errors = this.currentErrors;

    if (!errors) {
      this.messages = [];
      return;
    }
 
    this.showAlert = false;
    this.messages = [];
 
    if ('Data' in errors && errors.Exception) {
      if (Array.isArray(errors.Exception.Errors) && errors.Exception.Errors.length > 0) {
        this.messages = errors.Exception.Errors.map((item: { ErrorMessage: any; })=> item.ErrorMessage);
      } else if (errors.Exception.ErrorMessage) {
        this.messages.push(errors.Exception.ErrorMessage);
      }
    } else {
      const parsedErrors = this.parseErrorItems(errors);
      parsedErrors.forEach((itm: { Key?: string; Errors: string[] }) => {
        if (!this.ErrorKey) {
          if (this.isGlobalKey(itm.Key)) {
            this.messages = this.messages.concat(itm.Errors);
          }
        } else if (this.normalizeKey(itm.Key) === this.normalizeKey(this.ErrorKey)) {
          this.messages = this.messages.concat(itm.Errors);
        }
      });
    }
  }
  close() {
    this.showAlert = true;
  }
  public decline() {
    // this.activeModal.close(false);
  }

}
